import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login-v2-callback',
  templateUrl: './login-v2-callback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginV2CallbackComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    const code = this.activatedRoute.snapshot.queryParams.code;

    this.authService.loginWithCode(code).subscribe(() => {
      this.router.navigate(['/main']);
    });
  }
}
